<template>
  <div class="pages">
    <div class="content">
      <div class="fac guide">
        <div v-for="(item ,index) in newsInfo.wanhui_postion" >
          <span style="cursor: pointer;" @click="handleNavigation(item.cat_id, index)"> {{ item.position_name }}</span>
          <i v-if="(newsInfo.wanhui_postion.length -1) !== index" class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="title">
        {{ newsInfo.title }}
      </div>
      <div class="time">{{ newsInfo.release_time }}</div>
      <div class="devide"></div>
      <div class="cont" v-html="newsInfo.content"></div>
      <div class="cbox facac">
        <div @click="handleChangeNews(newsInfo.pre_id)"
             v-if="newsInfo.pre_id !=0 "
        >
          <i class="el-icon-arrow-left"></i> {{ $t('main.beforePage') }}：{{ newsInfo.pre_title }}
        </div>
        <div style="margin-left: 3.75rem;"
             @click="handleChangeNews(newsInfo.next_id)"
             v-if="newsInfo.next_id !=0 "
        >
        {{ $t('main.nextPage') }}：{{ newsInfo.next_title }}<i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getContentsDetail
} from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      newsInfo: {},
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail"
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init(id) {
      let params = {
        req: {
          id: id ? id : this.$route.params.content_id
        }
      };
      getContentsDetail(params).then(res => {
        if (res.rsp.code === 0) {
          this.newsInfo = res.data;
        }
      });
    },
    handleChangeNews(id) {
      this.init(id);
    },
    handleNavigation(id, index) {
      if(index === 0) {
        this.$router.push({
          path: "/"
        });
      } else {
        this.$router.push({
          path: "/news/" + id
        });
      }
    },
    handleTimeToString(v) {
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;
  .content {
    .guide {
      color: #999999;
    }

    .title {
      margin-top: 1.5rem;
      font-size: 1.285rem;
      text-align: center;
      color: #1a1a1a;
    }

    .time {
      margin-top: 1.5rem;
      text-align: center;
      color: #999999;
    }

    .devide {
      margin-top: 1.875rem;
      height: 1px;
      background: #f2f2f2;
    }

    .cont {
      padding: 30px 0;
      color: #1a1a1a;
    }

    .imgBox {
      margin-top: 1.875rem;

      .simg {
        width: calc(50% - 30px);
        height: 26.75rem;
      }

      .simg + .simg {
        margin-left: 3.75rem;
      }
    }

    .cbox {
      margin-top: 5rem;

      div {
        cursor: pointer;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .content {
      padding: 2.5rem 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 2.5rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 2.5rem 15%;
    }
  }
}
</style>
